<template>
  <div class="label-input">
    <label class="label">{{label}}</label>
    <input class="input calender-input" :id="dateId" v-model="date"/>
    <img @click="showDatePicker=true"  class='calender-icon' src='../../assets/icon/calendar.svg' />
    <date-picker class="calender-comp"  :custom-input="'#'+dateId"
                 :show='showDatePicker' popover="top-left"
                 v-model="date"
                 :autoSubmit="true"
                 id="birthday"
                 :format="$dateFormat['en']"
                 :display-format="$dateFormat['fa']"

    ></date-picker>
<!--    :format="$dateFormat['en']"-->
<!--    :display-format="$dateFormat['fa']"-->
<!--    :max="$jmoment().format($dateFormat['en'])"-->
<!--    -->
<!--    -->
  </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
export default {
  name: "Calendar.vue",
  components:{
    datePicker: VuePersianDatetimePicker
  },
  props:{
    label:String,
    dateId:String
  },
  watch: {
    'date'() {
      if (this.date)
        this.$emit('value',this.date)
    },
    'value'(){
      this.date=this.value
    }
  },
  data(){
    return{
      date:'',
      showDatePicker:false,
    }
  }
}
</script>

<style scoped>
.input{
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  flex-grow: 1;
  color: white;
  padding: 0 8px ;

}
.calender-icon{
  cursor: pointer;
}
.label-input{
  border: 1px solid #D7C8C8;
  box-sizing: border-box;
  border-radius: 4px;
  flex-grow: 1;
  flex-basis: 100px;
  display: flex;
  padding:4px  10px 4px 8px;
  align-items: center;
}

.label{
  color: #8C8585;
  font-size: clamp(11px,1.1vw,12px);
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}
</style>